import { create } from 'zustand';

interface NavigationStore {
  referrer: string;
  canGoBack: boolean | undefined;
  navigationType: NavigationTimingType | null;
  setReferrer: (value: string) => void;
  setCanGoBack: (value: boolean) => void;
  setNavigationType: (value: NavigationTimingType | null) => void;
  goBack: () => void;
  setGoBack: (value: () => void) => void;
}

export const useNavigationStore = create<NavigationStore>(set => ({
  referrer: typeof document !== 'undefined' ? document.referrer : '',
  setReferrer: value => set({ referrer: value }),
  canGoBack: undefined,
  setCanGoBack: value => set({ canGoBack: value }),
  navigationType:
    typeof window !== 'undefined'
      ? (
          window?.performance?.getEntriesByType?.(
            'navigation'
          )?.[0] as PerformanceNavigationTiming
        )?.type ?? null
      : null,
  setNavigationType: value => set({ navigationType: value }),
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  goBack: () => {},
  setGoBack: value => set({ goBack: value }),
}));
